import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Slider from 'react-slick';
import ArrowButton from 'components/ArrowButton';
import Link from 'components/Link';
import classes from './CardProductK.module.scss';

const CardProductK = (props) => {
  const {
    relatedProducts = [],
  } = props;

  const arrowProps = {
    iconClassName: classes.arrow,
    type: 'ArrowButtonB',
  };

  const renderTitle = (displayName, productDetailUrl) => {
    const title = (
      <div
        className={classes.displayName}
        dangerouslySetInnerHTML={{ __html: displayName }}
      />
    );

    if (productDetailUrl) {
      return (
        <Link href={productDetailUrl} target='_self' tabIndex={-1}>
          {title}
        </Link>
      );
    }
    return title;
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    }],
  };

  return (
    <Slider
      className={classes.container}
      {...settings}
      prevArrow={<ArrowButton {...arrowProps} />}
      nextArrow={<ArrowButton {...arrowProps} isNext />}
    >
      {relatedProducts && relatedProducts.map(({
        imageURI,
        imageAltText = '',
        displayName,
        shortDescription,
        productDetailUrl,
        productId,
        imageHeight,
        imageWidth,
      }) => (
        <div className={classes.item} key={productId}>
          {imageURI &&
            <img
              className={classes.image}
              src={imageURI}
              alt={imageAltText}
              width={imageWidth}
              height={imageHeight}
              loading='lazy'
            />}
          <div className={classes.productInfoContainer}>
            <div className={classes.productInfo}>
              {displayName && renderTitle(displayName, productDetailUrl, productId)}

              {shortDescription &&
                <div
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: shortDescription }}
                />}
            </div>
            {productDetailUrl &&
              <div className={classes.button} aria-hidden='true'>
                <Button
                  subType='ButtonA'
                  title='View Details'
                  rightIcon='far fa-chevron-right'
                  href={productDetailUrl}
                  target='_self'
                  tabIndex={-1}
                />
              </div>}
          </div>
        </div>
      ))}
    </Slider>
  );
};
export default CardProductK;

const ProductPropTypes = {
  displayName: PropTypes.string,
  imageAltText: PropTypes.string,
  imageURI: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  productDetailUrl: PropTypes.string,
  productId: PropTypes.string,
  shortDescription: PropTypes.string,
};

CardProductK.propTypes = {
  relatedProducts: PropTypes.arrayOf(PropTypes.shape(ProductPropTypes).isRequired),
};
